import { useGetMainList } from "ra-core";
import { FC, createContext, useContext, useMemo } from "react";
import { SimpleOption } from "@/components/governance/search/AmbientFacilitiesContext";
import { RoleResponseDto } from "@/gen/api/user";


interface UserManageAmbientDataContextProps {
  roles: (RoleResponseDto&SimpleOption)[];
}

const UserManageAmbientDataContext = createContext<UserManageAmbientDataContextProps>({} as any)

const rolesParams = {
  page: { page: 1, perPage: 1000 },
  sort: { field: '', order: '' },
  filter: {},
}

const UserManageAmbientDataContextProvider: FC = ({ children }) => {
  const { data } = useGetMainList('org-roles', rolesParams.page, rolesParams.sort, rolesParams.filter)
  const val = useMemo(() => ({
    roles: !data ? [] 
      : Object.values<RoleResponseDto&SimpleOption>(data as any).map(r => {
        r.key = `${r.organizationId}_${r.roleId}` as any
        r.text = r.name!
        return r
      }).sort((a, b) => a.name! < b.name! ? -1 : 1)
  }), [data])

  return (
    <UserManageAmbientDataContext.Provider value={val}>
      {children}
    </UserManageAmbientDataContext.Provider>
  )
}

export default UserManageAmbientDataContextProvider;

export const useUserManageAmbientDataContext = () => useContext(UserManageAmbientDataContext)

